module.exports = {
      id: "pdf-usage",
      viewBox: "0 0 21.946 21.946",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#pdf",
      toString: function () {
        return this.url;
      }
    }